export default __webpack_public_path__ + "static/media/C++_Logo.2441702d.svg";